import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tab',
  template: `
    <div [hidden]="!active" class="tab-content">
      <ng-content></ng-content>
    </div>
  `,
})
export class TabComponent {
  @Input('queryStringNav') queryStringNav: string;
  @Input('tabTitle') title: string;
  @Input('error') error: boolean;
  @Input('errorTooltip') errorTooltip: string;
  @Input('beta') beta: boolean;
  @Input('betaTranslation') betaTranslation: string;
  @Input() active = false;
}
